import { useCallback } from 'react';

import { useTranslate } from '@growtherapy/i18n';

import { useResetFaviconAndTitleCallback } from './useResetFaviconAndTitleCallback';

export function useClearProviderNoShowTabTitleCallback() {
  const t = useTranslate();
  const resetFaviconAndTitle = useResetFaviconAndTitleCallback();

  return useCallback(
    function clearProviderNoShowTabTitle() {
      if (document.title !== t('telehealth-core:meta.providerNotHere')) {
        return;
      }

      resetFaviconAndTitle();
    },
    [t, resetFaviconAndTitle],
  );
}
